import { Component, OnInit } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';
import { TermsOfServiceService } from './terms-of-service.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  standalone: false,
})
export class TermsOfServiceComponent implements OnInit {
  terms: string;
  submitting = false;

  constructor(
    private termsService: TermsOfServiceService,
    private snackbarService: SnackbarService,
    private readonly configService: AppConfigService,
  ) {}

  partnerName$ = this.configService.config$.pipe(map((config) => config.partnerName));
  partnerId$ = this.configService.config$.pipe(map((config) => config.partnerId));

  ngOnInit(): void {
    this.termsService.termsOfService.subscribe((terms) => {
      this.terms = terms;
    });
  }

  acceptTerms(): void {
    this.submitting = true;
    this.termsService.acceptTermsOfService().subscribe({
      next: () => (window.location.href = '/dashboard'),
      error: () => {
        this.snackbarService.errorSnack('Error accepting Terms of Service, please try again.');
        this.submitting = false;
      },
    });
  }
}
